package com.parmartechnologies.core.feature.employee.model

import com.parmartechnologies.core.extension.BaseDataClass
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class JobRole(
    @SerialName("name") var Name: String = "",
    @SerialName("description") var Description: String = "",
    @SerialName("is_deleted") var IsDeleted: Int = 0,
): BaseDataClass()


